const Neuron = ({ className }: { className?: string }) => (
    <svg
        width="138"
        height="138"
        className={className}
        viewBox="0 0 138 138"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M71.4532 32.6041C71.2646 32.3503 70.967 32.2008 70.6508 32.2008C70.3346 32.2008 70.037 32.3503 69.8483 32.6041L68.5276 34.3803C62.1114 43.0093 52.4171 48.6062 41.7361 49.8483L39.5375 50.104C39.2234 50.1405 38.9451 50.3235 38.787 50.5973C38.6289 50.8712 38.6096 51.2036 38.7351 51.4939L39.6129 53.5258C43.8777 63.3969 43.8777 74.5908 39.6129 84.4619L38.7351 86.4938C38.6096 86.784 38.6289 87.1165 38.787 87.3904C38.9451 87.6642 39.2234 87.8472 39.5375 87.8837L41.7361 88.1394C52.4171 89.3815 62.1114 94.9784 68.5276 103.607L69.8483 105.384C70.037 105.637 70.3346 105.787 70.6508 105.787C70.967 105.787 71.2646 105.637 71.4532 105.384L72.774 103.607C79.1902 94.9784 88.8844 89.3815 99.5654 88.1394L101.764 87.8837C102.078 87.8472 102.356 87.6642 102.515 87.3904C102.673 87.1165 102.692 86.784 102.566 86.4938L101.689 84.4619C97.4238 74.5908 97.4238 63.3969 101.689 53.5258L102.566 51.4939C102.692 51.2036 102.673 50.8712 102.515 50.5973C102.356 50.3235 102.078 50.1405 101.764 50.104L99.5654 49.8483C88.8844 48.6062 79.1902 43.0093 72.774 34.3803L71.4532 32.6041Z"
            stroke="#F5D7B9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle
            cx="69.0473"
            cy="68.8239"
            r="13.4985"
            stroke="#F5D7B9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Neuron;
